import {useEffect, useState} from "react";
import {getFilters} from "../../services/Administrative/ticketsService";

export const useGetFilters = () => {
    const [clients, setClients] = useState([]);
    const [services, setServices] = useState([]);
    const [states, setStates] = useState([]);

    useEffect(() => {
        const fetchFilters = async () => {
            try {
                const response = await getFilters();
                setClients(response.clients);
                setServices(response.services);
                setStates(response.states);
            } catch (error) {
                console.error('Error fetching filters:', error);
            }
        };
        fetchFilters();
    }, []);

    return { clients, services, states };
};
